import { Directive, forwardRef, HostListener } from '@angular/core';
import { DefaultValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
    selector: 'input[uppercase]',
    standalone: true,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => UppercaseDirective),
        },
    ]
})
export class UppercaseDirective extends DefaultValueAccessor {

    @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
        const input = event.target as HTMLInputElement;
        const start = input.selectionStart;
        input.value = input.value.toUpperCase();
        input.setSelectionRange(start, start);
        this.onChange(input.value);
    }

}
